
import { Placement } from '@post-office/placements-frontend/jira-rovo-dev-spotlight-walkthrough';
export default Placement;
